export class FeatureWellSearchCard {
    constructor(
        public title: string,
        public description: string,
        public imageUrl: string,
        public url: string
    ) {}

    public static fromData(data): FeatureWellSearchCard {
        // TODO: change after we have camel-case
        return new FeatureWellSearchCard(data.title, data.description, data.image_url, data.url)
    }
}
